import { DatePipe } from '@angular/common';
import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { FinoCommonModule } from '@fino-ui/common';
import { FinoIconModule } from '@fino-ui/icon';
import { FinoTranslationModule } from '@fino-ui/translation';
import { SortIconComponent } from '../../../components/sort-icon/sort-icon.component';
import { TICKET_TYPE_COLOR } from '../ticket-overview.constants';
import { TicketOverviewService } from '../ticket-overview.service';

@Component({
  selector: 'app-ticket-table',
  templateUrl: './ticket-table.component.html',
  styleUrls: ['./ticket-table.component.sass'],
  imports: [
    FinoTranslationModule,
    SortIconComponent,
    FinoCommonModule,
    FinoIconModule,
    DatePipe,
  ],
})
export class TicketTableComponent {
  private readonly ticketOverviewService = inject(TicketOverviewService);

  public readonly isLoading = input<boolean>(false);

  public readonly sortOrder = input<string | undefined>('');

  public readonly filterProperty = input<string | undefined>('');

  public readonly organization = input<string>('');

  @Output()
  public sortByFieldEvent = new EventEmitter();

  public readonly tickets = input<any>(undefined);

  getTicketColor(type: string) {
    return TICKET_TYPE_COLOR[type];
  }

  openTicket(ticket: any) {
    if (ticket.lockedBy) return;
    this.ticketOverviewService
      .getTicketLink(ticket.tenant, ticket.id, this.organization())
      .subscribe((res: any) => this.openKWH(res, ticket.id));
  }

  isValidDate(value: any): boolean {
    const date = new Date(value);
    return value && !Number.isNaN(date.getTime());
  }

  openKWH(response: any, id = '') {
    this.ticketOverviewService.openKWH(response, id);
  }

  public sortByField($event: any) {
    this.sortByFieldEvent.next($event);
  }
}
